import dict from "../../Data/dict.json"

export const array_to_sentence = (arr, lang) => {
  const language = lang || localStorage?.language

  if (arr.length === 0) return "";
  if (arr.length === 1) return arr[0];
  if (arr.length === 2) return `${arr[0]} ${dict["and"][language]} ${arr[1]}`;

  const lastElement = arr.pop();
  return `${arr.join(", ")}, ${dict["and"][language]} ${lastElement}`;
}

const TAG_MAP = {
  b: (c) => <strong style={{ fontWeight: 700 }}>{c}</strong>,
  i: (c) => <em>{c}</em>,
  u: (c) => <u>{c}</u>,
  s: (c) => <s>{c}</s>,
  mark: (c) => <mark>{c}</mark>,
  sup: (c) => <sup>{c}</sup>,
  sub: (c) => <sub>{c}</sub>,
  code: (c) => (
    <code style={{ background: "#eee", padding: "2px 4px", borderRadius: 4 }}>
      {c}
    </code>
  ),
};

export const parseRichText = (text) => {
  const regex = /{(\w+)}([\s\S]*?){\/\1}/;
  const match = text.match(regex);

  if (!match) return text;

  const [full, tag, content] = match;
  const before = text.slice(0, match.index);
  const after = text.slice(match.index + full.length);

  return (
    <span style={{ display: "inline" }}>
      {before}
      {TAG_MAP[tag] ? TAG_MAP[tag](parseRichText(content)) : content}
      {after && parseRichText(after)}
    </span>
  );
}